import { combineReducers } from 'redux';
import easyJoinDataReducer from './easyJoinDataReducer';
import easyJoinUIReducer from './easyJoinUIReducer';

export default combineReducers({
  data: easyJoinDataReducer,
  ui: easyJoinUIReducer,
});
